/* eslint-disable react-hooks/exhaustive-deps */
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { deleteWorkOthers, getWorkOtherList } from "../../../apis/work-schedule/other-work";
import PageHeader from "../../../components/PageHeader";
import { ControlTable } from "../../../components/Table";
import { permissionCheck } from "../../../utils/permission";
import systemAlert from "../../../utils/systemAlert";
import OtherWork from "./OtherWork";

const WorkScheduleOtherWork = (props) => {
  const history = useHistory()
  const { permissions } = useSelector(
    (store) => ({
      permissions: store.Profile.permissions,
    }),
  );
  const [fields] = useState([
    { title: "기타 근무 항목", key: "workName" },
    { title: "사유", key: "description" },
    {
      title: "사용 여부",
      key: "isActive",
      onTranslator: {
        list: [
          { label: "사용", value: true },
          { label: "미사용", value: false },
        ],
      },
    },
  ]);
  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [detailOpen, setDetailOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [formMode, setFormMode] = useState('create')
  const [targetPermission, setTargetPermission] = useState(null)

  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(p => p.code === 'OTHER_WORK_MANAGEMENT')
      setTargetPermission(permission)
      if (isEmpty(permission)) {
        permissionCheck(history, "OTHER_WORK_MANAGEMENT")
      }
    }
  }, [permissions])

  useEffect(() => {
    submit();
  }, []);

  const submit = () => {
    setIsLoading(true)
    getWorkOtherList()
      .then((res) => {
        setList(res.data.works);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false)
      })
  };

  const headerbuttons = [
    {
      label: "기타 근무 항목 추가",
      action: () => {
        setFormData({});
        setDetailOpen(true);
        setFormMode('create')
      },
    },
  ];

  const rowBtnConfig = {
    rowButtons: [
      {
        label: "삭제",
        type: "delete",
        className: "margin-right-8",
        action: (data) => {
          systemAlert('해당 기타근무를 삭제하시겠습니까?', {
            buttons: [
              {
                color: 'text',
                label: '취소'
              },
              {
                label: '삭제',
                onClick: () => {
                  setIsLoading(true)
                  deleteWorkOthers(data.workIdx)
                    .then(() => {
                      submit()
                    })
                    .catch(() => { })
                    .finally(() => {
                      setIsLoading(false)
                    })
                }
              }
            ]
          })
        },
      },
      {
        label: "수정",
        type: "edit",
        action: (data) => {
          setFormData(data);
          setDetailOpen(true);
          setFormMode('modify')
        },
      },
    ],
  };

  const handleRowClick = (data, e) => {
    const tagName = e.target.tagName
    if (!(tagName === 'TR' || tagName === 'TD')) return
    setFormData(data);
    setDetailOpen(true);
    setFormMode('view')
  }

  return (
    !isEmpty(targetPermission) && (
      <div className="page-content">
        <PageHeader title={"기타 근무 항목 설정"} buttons={targetPermission.level > 1 ? headerbuttons : []} />
        <ControlTable
          isHideControlHeader
          isLoading={isLoading}
          fields={fields}
          list={list}
          rowBtn={targetPermission.level > 1 ? rowBtnConfig : {}}
          onSelect={handleRowClick}
        />
        <OtherWork
          mode={formMode}
          selectedData={formData}
          open={detailOpen}
          setOpen={setDetailOpen}
          submit={submit}
        />
      </div>
    ));
};

export default WorkScheduleOtherWork;
